export enum PurchaseRequestType {
    Plastics = 'Plastics',
    Metals = 'Metals',
    C3 = 'C3',
    Custom = 'Custom',
}